import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppKit, useAppKitAccount } from '@reown/appkit/react';

export default function DepositGuide() {
  const navigate = useNavigate();
  const { open: openWalletModal } = useAppKit();
  const { address: mmAddress, isConnected } = useAppKitAccount();
  const [copied, setCopied] = useState(false);

  const copyAddress = () => {
    if (!mmAddress) return;
    navigator.clipboard.writeText(mmAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="deposit-guide-page">
      <h2>Deposit USDC</h2>
      <p className="deposit-guide-subtitle">You need USDC in your wallet (Base network) to use Finema. From Binance:</p>

      <div className="deposit-steps">
        <div className="deposit-step">
          <span className="deposit-step-number">1</span>
          <div className="deposit-step-content">
            <strong>Open Binance</strong>
            <p>Go to the "Withdraw" section</p>
          </div>
        </div>

        <div className="deposit-step">
          <span className="deposit-step-number">2</span>
          <div className="deposit-step-content">
            <strong>Select USDC</strong>
            <p>Search and select the USDC coin</p>
          </div>
        </div>

        <div className="deposit-step">
          <span className="deposit-step-number">3</span>
          <div className="deposit-step-content">
            <strong>Select the Base network</strong>
            <p>Make sure to select the <strong>Base</strong> network</p>
          </div>
        </div>

        <div className="deposit-step">
          <span className="deposit-step-number">4</span>
          <div className="deposit-step-content">
            <strong>Paste your wallet address</strong>
            {isConnected && mmAddress ? (
              <div className="wallet-address-copy">
                <code>{mmAddress}</code>
                <button className="wallet-copy-btn" onClick={copyAddress} title="Copy address">
                  {copied ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  ) : (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                  )}
                </button>
              </div>
            ) : (
              <button className="btn btn-outline" onClick={() => openWalletModal()} style={{ marginTop: 8 }}>
                Connect wallet to see your address
              </button>
            )}
          </div>
        </div>

        <div className="deposit-step">
          <span className="deposit-step-number">5</span>
          <div className="deposit-step-content">
            <strong>Confirm the withdrawal</strong>
            <p>Make sure the address and network are correct, then confirm. The USDC will appear in your wallet.</p>
          </div>
        </div>
      </div>

      <button className="btn btn-primary deposit-back-btn" onClick={() => navigate('/wallet')}>
        Back to my wallet
      </button>
    </div>
  );
}
